import { FC, useEffect, useState } from "react"
import { ProveedoresEntradasKPI } from "../../ScenarioPlan/ProveedoresInternosLayout/ProveedoresEntradas/ProveedoresEntradasKPI/ProveedoresEntradasKPI"
import ReactApexChart from "react-apexcharts"
import { STATE_ENTREGAS_INITIAL_STATE, STATE_ENTREGAS_OPERATIVO_INITIAL_STATE } from "../../../data/constants"

export const StockInicial:FC<any> = (props):JSX.Element => {

    const { stock } = props

    const [stateEntregas, setStateEntregas] = useState<any>(STATE_ENTREGAS_OPERATIVO_INITIAL_STATE)

    useEffect(() => {
        
        let categorias = stock?.stock_series[0]?.aux.map((a:any) => `W${a[0].semana}`)
       
        setStateEntregas({...stateEntregas,series:[
            {
                name: stock?.stock_series[0]?.name,
                data: stock?.stock_series[0]?.data,
                
              }
        ],options: {...stateEntregas.options,xaxis:{...stateEntregas.options.xaxis,categories:categorias},aux: stock?.stock_series[0]?.aux}})
    },[])

    return(
        <div className="entregas__wrapper">
            <div className="entregas__botonera" style={{height:'20%'}}>
                {
                    stock.stock_kpis.map((s:any,index:number) => {
                        return (
                            <ProveedoresEntradasKPI key={index} title={s.title} valueA={parseFloat(s.value).toFixed(2)} />
                        )
                    })
                }
   
            </div>
            <div className="entregas__table" style={{height:'80%'}}>
                <div style={{height:'100%',width:'100%'}}>
                    <ReactApexChart options={stateEntregas.options} series={stateEntregas.series} type="bar" height={'100%'} />
                </div>
            </div>
        </div>
    )
}